var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-modal",
        {
          attrs: { width: 900, cancelText: "false" },
          on: {
            ok: function($event) {
              _vm.visible = false
            }
          },
          model: {
            value: _vm.seeVisible,
            callback: function($$v) {
              _vm.seeVisible = $$v
            },
            expression: "seeVisible"
          }
        },
        [
          _c("template", { slot: "title" }, [
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c("icon-font", {
                  staticStyle: {
                    "margin-right": "3px",
                    "font-size": "20px",
                    "line-height": "0"
                  },
                  attrs: { type: "gb-icon-gonggao" }
                }),
                _c("span", {
                  directives: [
                    {
                      name: "ucstr",
                      rawName: "v-ucstr",
                      value: _vm.$t("common_home_announcement", [
                        _vm.$t("common_conj_system")
                      ]),
                      expression:
                        "$t('common_home_announcement', [$t('common_conj_system')])"
                    }
                  ]
                })
              ],
              1
            )
          ]),
          _vm.announcementList.length
            ? _c(
                "tips",
                {
                  staticStyle: {
                    margin: "0 -24px",
                    "border-top": "none",
                    "border-radius": "0"
                  }
                },
                [
                  _c(
                    "span",
                    { staticStyle: { "margin-right": "30px" } },
                    [
                      _c("icon-font", { attrs: { type: "gb-icon-voice-o" } }),
                      _c("span", {
                        directives: [
                          {
                            name: "ucstr",
                            rawName: "v-ucstr",
                            value: _vm.$t("common_home_announcement", [
                              "",
                              _vm.$t("common_conj_type")
                            ]),
                            expression:
                              "$t('common_home_announcement', ['', $t('common_conj_type')])"
                          }
                        ]
                      }),
                      _vm._v(
                        " ：" +
                          _vm._s(
                            _vm.newsType[
                              _vm.announcementList[_vm.announcementIndex]
                                .announcementType
                            ]
                          ) +
                          " "
                      )
                    ],
                    1
                  ),
                  _c(
                    "span",
                    [
                      _c("icon-font", { attrs: { type: "gb-icon-shijian" } }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("common_conj_time")) +
                            "：" +
                            _vm._s(
                              _vm
                                .moment(
                                  _vm.announcementList[_vm.announcementIndex]
                                    .announcementOnTime
                                )
                                .format("YYYY-MM-DD HH:mm")
                            )
                        )
                      ])
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.announcementList.length
            ? _c("div", { ref: "information", staticClass: "information" }, [
                _c("div", { staticClass: "information-box-conter" }, [
                  _vm.isLoading
                    ? _c(
                        "div",
                        { staticClass: "information-box-conter_loading" },
                        [_c("a-spin")],
                        1
                      )
                    : _vm._e(),
                  !_vm.isLoading
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "information-box-conter_title" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.announcementList[_vm.announcementIndex]
                                  .announcementTitle
                              )
                            )
                          ]
                        ),
                        _c("div", {
                          directives: [
                            {
                              name: "loaded",
                              rawName: "v-loaded",
                              value:
                                _vm.announcementList[_vm.announcementIndex]
                                  .announcementContent,
                              expression:
                                "announcementList[announcementIndex].announcementContent"
                            },
                            {
                              name: "viewer",
                              rawName: "v-viewer.static",
                              value: { movable: false },
                              expression: "{movable: false}",
                              modifiers: { static: true }
                            }
                          ],
                          staticClass: "mce-content-body",
                          staticStyle: { padding: "0" }
                        })
                      ])
                    : _vm._e()
                ]),
                _vm.announcementList[_vm.announcementIndex].enclosureList &&
                _vm.announcementList[_vm.announcementIndex].enclosureList.length
                  ? _c(
                      "div",
                      {
                        staticClass: "information-box-conter",
                        staticStyle: { "margin-top": "27px" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "information-box-conter_title" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("common_btn_download_attachment"))
                            )
                          ]
                        ),
                        _vm._l(
                          _vm.announcementList[_vm.announcementIndex]
                            .enclosureList,
                          function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "detail-header-span iconfont-left"
                              },
                              [
                                _c("i", {
                                  staticClass: "iconfont gb-icon-wendang"
                                }),
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.enclosureClick(
                                          item.enclosureFileUrl,
                                          item.enclosureFileName
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(item.enclosureFileName))]
                                )
                              ]
                            )
                          }
                        )
                      ],
                      2
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _c(
            "template",
            { slot: "footer" },
            [
              _vm.announcementIndex < _vm.announcementList.length - 1
                ? _c(
                    "a-button",
                    {
                      staticStyle: { height: "32px" },
                      attrs: { loading: _vm.isLoading },
                      on: { click: _vm.nextClick }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("common_btn_next_tiao", [
                              _vm.$t("common_home_announcement", [])
                            ])
                          ) +
                          " "
                      )
                    ]
                  )
                : _c(
                    "a-button",
                    {
                      staticStyle: { height: "32px" },
                      on: { click: _vm.closeClick }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common_btn_i_know")) + " ")]
                  ),
              _c(
                "a-button",
                {
                  staticStyle: { height: "32px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.informationClick }
                },
                [_vm._v(" " + _vm._s(_vm.$t("common_btn_know_more")) + " ")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }